module.exports = __webpack_public_path__ + "static/media/instagram.07e509ef.png";